import { createFileRoute } from '@tanstack/react-router';
import { ErrorLogTable } from '~/components/admin/ErrorLogTable';

export const Route = createFileRoute('/_app/admin/error-log')({
  component: ErrorLogTable,
});
